var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSaveActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 19,
    height: 19,
    rx: 1.5,
    stroke: "#8C2148"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.65545,
    height: 12.0001,
    transform: "translate(13)",
    fill: "#EAECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9398 0.333068C16.6974 0.506168 15.7281 1.44091 14.7933 2.38719C13.4085 3.79507 13.0854 4.18743 13.0277 4.53363C12.8546 5.45682 13.5124 6.18384 14.4356 6.07998C14.8972 6.03382 15.0588 5.92996 15.7512 5.23756L16.5474 4.45285V7.83406V11.2153L16.9398 11.6076C17.2514 11.9192 17.4245 12 17.7937 12C18.3823 12 18.9131 11.573 19.0862 10.9845C19.1439 10.7421 19.2016 9.25348 19.2016 7.56864V4.57979L19.9979 5.34142C20.7364 6.06844 20.8288 6.1146 21.3134 6.1146C22.2366 6.1146 22.8367 5.31834 22.6059 4.41823C22.5251 4.07203 18.9939 0.425388 18.4861 0.159968C17.9899 -0.105452 17.4475 -0.0362116 16.9398 0.333068Z",
    fill: "#8C2148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 43H35",
    stroke: "#8C2148",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSaveActive);
export default __webpack_public_path__ + "static/media/addSaveActive.43d5896151133396fad020f7ff25d6b9.svg";
export { ForwardRef as ReactComponent };